export class PreOrPostAssessmentGraphOfData {
  slides: SlidePreOrPostAssessment[];
  traineeOverallScores: TraineeOverallScore[];
  referenceCorrectAnswers: ReferenceCorrectAnswers[];
}

export class SlidePreOrPostAssessment {
  slideName: string;
  questions: QuestionPreOrPostAssessment[];
  scorePercentage: number;
}

export class QuestionPreOrPostAssessment {
  questionId: string;
  traineeResponses: TraineeResponse[]
  correctPercentage: number;
}

export class TraineeResponse {
  key: Key;
  value: string;
  answers: Answer[];
  trainee: any;
}

export class Key {
  userId: string;
  name: string;
}

export class TraineeOverallScore {
  key: Key;
  value: number;
}

export class ReferenceCorrectAnswers {
  answer: string;
  question: string;
}

export class Answer {
  answer: string;
  userAnswer: string;
}
